/** Duration parsing helpers for bulk task edit. */
import { parseDurationInput } from '@/utils/timeUtils';

/** @param {string|symbol} duration @param {symbol} untouchedSymbol */
export const isDurationFieldInvalid = (duration, untouchedSymbol) =>
  duration !== untouchedSymbol &&
  duration !== '' &&
  parseDurationInput(duration) === null;

export const parseDurationFieldHandler = (value, updates, untouchedSymbol) => {
  if (value === untouchedSymbol) return;
  if (value === '') {
    updates.duration = null;
    return;
  }
  const parsed = parseDurationInput(value);
  if (parsed !== null) {
    updates.duration = parsed;
  }
};
